import clientUtils from '../Utils/clientUtils';

export class SearchForm {
  keyword: string = '';
  type: string = 'ai';
  category: string | null = null;
  sort: string | null = 'Relevance';
  modelType: string | null = null;
  paginationId: string | null = null;

  static createForm() {
    const form = new SearchForm();
    return form;
  }

  static GetQueryString(data: any, paginationObj) {
    // console.log('data', data);
    const form = {};
    let queryString = '';
    const aisearch = data.type === 'ai' ? true : false;
    if (clientUtils.isEmpty(data.paginationId)) {
      if (!clientUtils.isEmpty(data.category)) {
        Object.assign(form, { category: data.category });
      }
      if (!clientUtils.isEmpty(data.modelType)) {
        Object.assign(form, { modelType: data.modelType });
      }
      if (!clientUtils.isEmpty(data.sort)) {
        Object.assign(form, { sort: data.sort });
      }
      if (!clientUtils.isEmpty(data.keyword)) {
        Object.assign(form, { searchTerm: data.keyword });
      }
      Object.assign(form, {
        aisearch: aisearch,
        pageCount: paginationObj.rowsPerPage,
        page: paginationObj.page,
      });
    }

    if (!clientUtils.isEmpty(data.paginationId)) {
      Object.assign(form, {
        paginationId: data.paginationId,
        pageCount: paginationObj.rowsPerPage,
        page: paginationObj.page,
      });
    }
    queryString = clientUtils.convertToQueryString(form);
    return queryString;
  }
}
